import React from "react";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const Hero = () => (
  <section className="hero">
    <div className="hero-bg" />
    <div className="hero-content">
      <div className="hero-tag"><span className="live-dot" />ATTOM-Sourced Market Data · Latest Monthly Report: August 2026 · Updated As Published</div>
      <h1 className="hero-main">A Ready-to-Deploy<br /><em>Early-Intervention Framework</em><br />for Mortgage Servicers</h1>
      <p className="thirty-year-statement" style={{ marginTop: "1.5rem" }}>Identify emerging borrower risk earlier. Prioritize intervention. Standardize engagement. Document decisions. Measure outcomes.</p>
      <p className="hero-lead">
        Mortgage Survival Playbook 2026 is a self-contained institutional implementation framework designed to help servicing organizations identify emerging borrower risk, organize earlier intervention, document decisions, and evaluate outcomes using institution-approved data and existing governance processes.
      </p>
      <div style={{ margin: "1.5rem auto 2rem", maxWidth: 520 }}>
        <div style={{ fontFamily: "var(--serif)", fontSize: "1.6rem", fontWeight: 800, color: "var(--gold2)" }}>$4,995 Institutional License</div>
        <div style={{ fontSize: "0.82rem", color: "var(--g3)", marginTop: "0.25rem" }}>One license covers your portfolio.</div>
      </div>
      <div className="hero-dual-cta">
        <button className="btn-hero" onClick={() => scrollTo("preview")}>Request Free Institutional Preview →</button>
        <button className="btn-hero-secondary" onClick={() => scrollTo("included")}>See What's Included</button>
      </div>
      <div className="hero-sub">
        <button onClick={() => scrollTo("purchase")} style={{ background: "none", border: "none", color: "var(--g3)", cursor: "pointer", textDecoration: "underline", fontSize: "0.74rem", fontFamily: "var(--sans)" }}>Request Institutional Invoice &amp; W-9</button>
      </div>
      <div className="compliance-strip" style={{ justifyContent: "center", marginTop: "2.2rem" }}>
        <div className="cb">Runs alongside existing servicing systems</div>
        <div className="cb">Institution-controlled data</div>
        <div className="cb">Governance review resources included</div>
        <div className="cb">90-day implementation roadmap</div>
      </div>
    </div>
  </section>
);

export default Hero;
